import { ReactNode } from "react";

import { TwcPageSwitcher } from "../../views/onboarding-wizard/wizard/page-switcher/twc-page-switcher";
import { TwcProvisioningScreen } from "../../views/twc-provisioning-screen/twc-provisioning-screen";
import JiraUserSegmentationView from "../../views/user-seg-bxp-ui/user-segmentation";
import WorkOnFirstView from "../../views/work-on-first";
import { PerceivedProvisioningStartTimer } from "../perceived-provisioning/perceived-provisioning-start-timer";

import {
    PROVISIONING,
    ProvisioningScreenKey,
    TEAM_CHOICE,
    TWC_PAGE_SWITCHER,
    WORK_ON_FIRST
} from "./utils";

export type ScreenList = ProvisioningScreenKey[];
export const teamChoiceDictionaryItem = {
    [TEAM_CHOICE]: <JiraUserSegmentationView />
} as const;
export const workOnFirstDictionaryItem = {
    [WORK_ON_FIRST]: <WorkOnFirstView />
} as const;
export const provisioningUIDictionaryItem = {
    [PROVISIONING]: (
        <PerceivedProvisioningStartTimer>
            <TwcProvisioningScreen />
        </PerceivedProvisioningStartTimer>
    )
} as const;
export type ScreenDictionary = Partial<
    Record<ProvisioningScreenKey, ReactNode>
>;
export const twcPageSwitcherDictionaryItem = {
    [TWC_PAGE_SWITCHER]: <TwcPageSwitcher />
} as const;

export const twcScreenDictionary: ScreenDictionary = {
    ...teamChoiceDictionaryItem,
    ...workOnFirstDictionaryItem,
    ...twcPageSwitcherDictionaryItem,
    ...provisioningUIDictionaryItem
};
